import { useMemo } from 'react';

export const useRows = (data, isGroupByDate = false) =>
  useMemo(() => {
    return Object.entries(data).map(([title, value]) => {
      const info = value.shifts ? value.shifts : value
      const resultInfo = isGroupByDate ? Object.values(info) : info

      const items = resultInfo.map((item) => {
        const resultItem = Array.isArray(item) ? item : item.shifts[0];
        const [name, employee, fromDate, toDate, jobClassCode, payCode, hours] =
          resultItem

        return {
          name,
          employee,
          fromDate,
          toDate,
          jobClassCode,
          payCode,
          hours,
        };
      });

      return { title, items };
    });
  }, [data, isGroupByDate]);
